import React from 'react';
import Sidebar from './Sidebar';

interface AppLayoutProps {
  children: React.ReactNode;
  activeRoute: string;
}

export default function AppLayout({ children, activeRoute }: AppLayoutProps) {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar activeRoute={activeRoute} />
      <main className="flex-1 min-w-0 overflow-x-hidden">
        <div className="max-w-screen-2xl mx-auto px-3 sm:px-4 lg:px-8 xl:px-10 2xl:px-16 pt-16 pb-8 lg:pt-8">
          {children}
        </div>
      </main>
    </div>
  );
}